import { BuildRentType } from './BuildRentType';

export enum BuildWorkDescriptionType {
    JustRenovating = 0,
    RenovatePlusNewSqFt = 1,
    AllNewConstruction = 2,
}

export const BuildWorkDescriptionTypeOptions = [
    {
        id: BuildWorkDescriptionType.JustRenovating,
        display: 'Just renovating existing space',
        buildRentTypeId: BuildRentType.FixRent,
    },
    {
        id: BuildWorkDescriptionType.RenovatePlusNewSqFt,
        display: 'Renovate + Add New Square Footage',
        buildRentTypeId: undefined as BuildRentType | undefined,
    },
    {
        id: BuildWorkDescriptionType.AllNewConstruction,
        display: 'All new construction',
        buildRentTypeId: BuildRentType.BuildRent,
    },
];
